import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UBXGridModule } from '../grid/grid.module';
import { UBXIconModule } from '../icon/icon.module';
import { UBXSnackbarComponent } from './snackbar.component';
import { UBXSnackbarSnackComponent } from './snack/snackbar-snack.component';

const Imports = [
    UBXGridModule,
    UBXIconModule,
];
const Module = [
    UBXSnackbarComponent,
    UBXSnackbarSnackComponent,
];

@NgModule({
    declarations: [
        Module
    ],
    imports: [
        CommonModule,
        Imports
    ],
    exports: [
        Module
    ],
})
export class UBXSnackbarModule {}
